import React, { useState } from 'react';
import Select from 'react-select';
import '../styles/ValidacionDocumento.css';

const ValidacionDocumentoAPI = ({ formData, handleChange, onDocumentoValidado, setFormData, documentoExistente }) => {
  const [validando, setValidando] = useState(false);
  const [mostrarMensaje, setMostrarMensaje] = useState(false);
  const [mensajeValidacion, setMensajeValidacion] = useState('');

  const tipoDocumentoOptions = [
    { value: 'cc', label: 'Cédula de Ciudadanía (CC)' },
    { value: 'ti', label: 'Tarjeta de Identidad (TI)' },
    { value: 'ce', label: 'Cédula de Extranjería (CE)' },
    { value: 'pasaporte', label: 'Pasaporte' },
    { value: 'pep', label: 'Permiso Especial de Permanencia (PEP)' },
    { value: 'salvoconducto', label: 'Salvoconducto' }
  ];

  // Nueva función que usa JSONP (evita CORS completamente)
  const validarDocumentoConJSONP = () => {
    if (!formData.tipoDocumento || !formData.numeroDocumento) {
      setMensajeValidacion('Elige tipo de documento e ingresa el número');
      setMostrarMensaje(true);
      return;
    }

    setValidando(true);
    setMostrarMensaje(false);

    // Crear callback global para JSONP
    const callbackName = 'handleDocumentoResponse_' + Date.now();
    
    // Definir callback global
    window[callbackName] = function(result) {
      setValidando(false);
      
      if (result.status === 'encontrado') {
        // Documento encontrado - cargar datos
        setMensajeValidacion('Documento encontrado. Datos cargados correctamente.');
        setMostrarMensaje(true);
        
        setTimeout(() => {
          onDocumentoValidado(true, result.datos);
        }, 1500);
        
      } else if (result.status === 'no_encontrado') {
        // Documento no encontrado - limpiar formulario y permitir registro nuevo
        setMensajeValidacion('Documento no encontrado. Puedes continuar con tu registro.');
        setMostrarMensaje(true);
        
        // Limpiar el formulario para nuevo registro
        setFormData({
          ...formData, // Mantener todos los valores existentes incluyendo aceptaTerminos y autorizaImagen
          tipoDocumento: formData.tipoDocumento, // Mantener documento validado
          numeroDocumento: formData.numeroDocumento, // Mantener documento validado
          nombre: '',
          apellido: '',
          email: '',
          telefono: '',
          fechaNacimiento: '',
          nombreIglesia: '',
          pastorIglesia: '',
          ciudadIglesia: '',
          denominacion: '',
          tallerPreferencia: '',
          tallerPreferencia2: '',
          necesidadesEspeciales: '',
          comoSeEntero: '',
          comentarios: '',
          comprobantePago: '',
          metodoPago: 'archivo',
          menoresEdad: '',
          nombresMenores: '',
          alimentacionCenaViernes: '',
          alimentacionAlmuerzoSabado: '',
          alimentacionCenaSabado: '',
          restriccionesAlimenticias: '',
          fechaRegistro: ''
        });
        
        setTimeout(() => {
          onDocumentoValidado(false);
        }, 1500);
        
      } else {
        // Error
        setMensajeValidacion('Error al validar documento: ' + (result.message || 'Error desconocido'));
        setMostrarMensaje(true);
      }
      
      // Limpiar callback
      delete window[callbackName];
      document.head.removeChild(script);
    };

    // Crear script para JSONP
    const script = document.createElement('script');
    // ENDER const scriptURL = 'https://script.google.com/macros/s/AKfycbw7J6SXQNpRTXQG5d2a8Zi957ek9ClV3wdj45o0AEuIf7bjyo5s_41Q6A1LlwMeFQv-/exec';
     const scriptURL = 'https://script.google.com/macros/s/AKfycbw2I01eLbeU7GYTj5KrtFNpiGP-7C3MqDRwqzN7-VNYQPLRESOHtbnfgMRUvBfIhC4lJw/exec';
    
    script.src = `${scriptURL}?callback=${callbackName}&accion=buscar_documento&tipoDocumento=${encodeURIComponent(formData.tipoDocumento)}&numeroDocumento=${encodeURIComponent(formData.numeroDocumento)}`;
    script.onerror = function() {
      setValidando(false);
      setMensajeValidacion('Error al validar documento. Por favor, intenta de nuevo.');
      setMostrarMensaje(true);
      delete window[callbackName];
    };
    
    document.head.appendChild(script);
  };

  const handleSelectChange = (selectedOption, fieldName) => {
    setFormData(prev => ({ 
      ...prev, 
      [fieldName]: selectedOption ? selectedOption.value : '' 
    }));
  };

  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#f9fafb',
      borderColor: '#d1d5db',
      minHeight: '48px',
      '&:hover': {
        borderColor: '#3A7D5C',
      }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#3A7D5C' : state.isFocused ? '#f0fdf4' : 'white',
      color: state.isSelected ? 'white' : '#374151',
      '&:hover': {
        backgroundColor: '#3A7D5C',
        color: 'white',
      }
    }),
    menu: (provided) => ({
      ...provided,
      border: '1px solid #d1d5db',
      borderRadius: '8px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
      zIndex: 50
    })
  };

  return (
    <div className="validacion-documento-container">
      <div className="validacion-documento-content">
        <div className="validacion-documento-header">
          <h2 className="validacion-documento-title">Validación de Documento</h2>
          <p className="validacion-documento-subtitle">
            Ingresa tu documento para verificar si ya tienes un registro
          </p>
        </div>

        <div className="validacion-documento-form">
          <div className="form-grid-2">
            <div className="form-field">
              <label className="form-label">Tipo de Documento *</label>
              <Select
                value={tipoDocumentoOptions.find(option => option.value === formData.tipoDocumento)}
                onChange={(selectedOption) => handleSelectChange(selectedOption, 'tipoDocumento')}
                options={tipoDocumentoOptions}
                placeholder="Selecciona tipo de documento"
                styles={customSelectStyles}
                isClearable={false}
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>

            <div className="form-field">
              <label className="form-label">Número de Documento *</label>
              <input
                type="text"
                name="numeroDocumento"
                value={formData.numeroDocumento}
                onChange={handleChange}
                placeholder="Ingresa tu número de documento"
                className="input-base"
                required
              />
            </div>
          </div>

          <div className="validacion-documento-buttons">
            <button
              type="button"
              onClick={validarDocumentoConJSONP}
              disabled={validando}
              className="btn btn-primary"
            >
              {validando ? (
                <>
                  <span className="spinner"></span>
                  Validando...
                </>
              ) : (
                'Validar Documento'
              )}
            </button>
          </div>

          {mostrarMensaje && (
            <div style={{
              marginTop: '1rem',
              padding: '1rem',
              borderRadius: '8px',
              fontSize: '0.875rem',
              fontWeight: '500',
              backgroundColor: '#f0fdf4',
              border: '1px solid #bbf7d0',
              color: '#166534'
            }}>
              {mensajeValidacion}
            </div>
          )}

          {documentoExistente && (
            <div className="documento-existente-info">
              <p>✅ <strong>Documento encontrado:</strong> Los datos han sido cargados automáticamente.</p>
              <p>Puedes editar la información o actualizar tu comprobante de pago.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ValidacionDocumentoAPI;
